import { MemberList } from 'ui/components/buyer/patterns/MemberList/MemberList';

/**
 * 買い手メンバー一覧
 */
export const BuyerMemberList: React.FC = () => {
    return <MemberList />;
};
